import { useState, useContext, useEffect } from "react";
import { Mails, X } from "lucide-react"; // Close icon
import { createPortal } from "react-dom";
import { BackendContext } from '../Context/BackendContext';

const NavbarNewsItem = () => {
  const [showModal, setShowModal] = useState(false);
  const [activeNews, setActiveNews] = useState(null);
  
  const [unreadNewsCount, setUnreadNewsCount] = useState(0);
  const [newsItems, setNewsItems] = useState([]);

  const { fetchLatestNews, userProfile, updateUserLastSeenNews } = useContext(BackendContext);

  useEffect(() => {
    if(!userProfile) {
      return; // If userProfile is not loaded yet, do nothing
    }
    const loadNewsAndCheckUnread = async () => {
      const latestNews = await fetchLatestNews(); // Assume this returns array with .timestamp
      //console.log("number of new items returned: ", latestNews.length)
      setNewsItems(latestNews || []);

      const lastSeen = userProfile?.lastSeenNewsAt || "1970-01-01T00:00:00.000Z";

      const unread = latestNews?.filter((item) => {
        return item.timestamp > lastSeen;
      }).length;

      setUnreadNewsCount(unread);
    };

    loadNewsAndCheckUnread();
  }, [userProfile.sub]);

  const toggleModal = async () => {
    const opening = !showModal;
    setShowModal(opening);
    setActiveNews(null);

    if (opening) {
      //const latestNews = await fetchLatestNews();
      //setNewsItems(latestNews || []);
      setUnreadNewsCount(0);
      await updateUserLastSeenNews(); // update backend timestamp
    }
  };

  return (
    <div>
      {/* Mail Icon with badge */}
      <div className="cursor-pointer relative" onClick={toggleModal}>
        <Mails className="w-6 h-6 text-white" />
        {unreadNewsCount > 0 && (
          <span className="absolute -top-3 -right-4 bg-red-500 text-white text-xs font-bold px-1.5 py-0.5 rounded-full">
            {unreadNewsCount}
          </span>
        )}
      </div>

      {/* Modal */}
      {showModal &&
        createPortal(
          <div className="fixed inset-0 z-[1000] bg-black bg-opacity-70 flex items-center justify-center">
            <div className="bg-slate-900 rounded-xl w-full max-w-md max-h-[90vh] overflow-y-auto p-6 relative text-white shadow-lg border border-slate-600">
              {/* Close button */}
              <button
                onClick={toggleModal}
                className="absolute top-3 right-4 text-white hover:text-red-400"
              >
                <X />
              </button>

              {/* Header */}
              <h2 className="text-xl font-bold mb-4 text-center">Latest News</h2>

              {/* News List */}
              {!activeNews ? (
                <ul className="space-y-2">
                  {newsItems.map((news) => (
                    <li 
                      key={news.id}
                      onClick={() => setActiveNews(news)}
                      className="hover:translate-x-1 transition-transform duration-150 cursor-pointer border border-slate-700 rounded-lg p-3 hover:bg-slate-800 transition"
                    >
                      <h4 className="text-base font-semibold text-white mb-1">
                        {news.title}
                      </h4>
                      <p className="text-xs text-gray-500">{new Date(news.timestamp).toLocaleDateString()}</p>
                      {news.description ? (
                        <p className="text-sm text-gray-400">
                          {news.description}
                        </p>
                      ) : (
                        <p className="text-sm text-gray-400 whitespace-pre-line">
                          {news.content}
                        </p>
                      )}
                    </li>
                  ))}
                </ul>
              ) : (
                <div>
                  <button
                    onClick={() => setActiveNews(null)}
                    className="text-sm text-blue-400 mb-2 hover:underline"
                  >
                    ← Back to news list
                  </button>
                  <h3 className="text-lg font-bold mb-2">{activeNews.title}</h3>
                  <p className="text-sm text-gray-300 whitespace-pre-line">
                    {activeNews.content.replace(/\\n/g, '\n')}
                  </p>
                </div>
              )}
            </div>
          </div>,
          document.body
        )}
    </div>
  );
};

export default NavbarNewsItem;
